module.exports = ".blue_text {\n\tcolor: #1427e6;\n\tmargin: 0px;\n\topacity: 1;\n}\n\n.vcw-page-content{\n    position: relative;\n}\n\nh2.blue_text {\n\tfont-size: 21px;\n\tfont-weight: 900;\n}\n\n.doodle img{\n    width: 25%;\n}\n\n.bottom{\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.bottom_button{\n    margin-top: 16px;\n}\n\n.button_block:hover {\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/verify-contact-warning/verify-contact-warning.component.css
// module id = ./src/app/auth/verify-contact-warning/verify-contact-warning.component.css
// module chunks = main